import { useMemo } from "react";
import { useAuth } from "../contexts/AuthContext";
import { isProductManager } from "../utils/productManagerAccess";
import { getDecodedToken } from "../utils/jwtUtils";

export function useIsProductManager(): boolean {
  const { user } = useAuth();

  return useMemo(() => {
    const fromUser = user?.roles;
    if (fromUser?.length) {
      return isProductManager(fromUser);
    }
    const decoded = getDecodedToken();
    return isProductManager(decoded?.roles);
  }, [user?.roles]);
}
